module.exports = __webpack_public_path__ + "static/media/cancel.6ab6e421.svg";